import { Component, Vue, Watch } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import WithRender from './productGrid.html';
import productInfo from '@/store/modules/products'
import { ProductRow, PriceList } from '@/types/ProductTypes';
import VuePhoneNumberInput from "vue-phone-number-input";
import prdts from "@/settings/products";
import { ProductSettings, ProductData } from '@/types/productSettingTypes';
import Modal from "../../components/Modal.vue";
import { CartLineItem } from '@/types/productGridTypes';
import { mapGetters } from 'vuex';

@WithRender
@Component({
  components: {
    Loading,
    VuePhoneNumberInput,
    Modal
  },
  computed: {
    ...mapGetters("productGridStore", {itemsInCart:"cartLineItemArr",basketTotalCost:"cartTotalAmount"}),
  }
})
export default class ProductGrid extends Vue {

  itemsInCart!: CartLineItem[];
  priceList: PriceList = {} as PriceList;
  productSetting: ProductSettings = prdts;
  product = {} as ProductData;
  location = "";
  currentPage = 1;
  rows = 0;
  perPage = 0;
  isLoading = false;

  showNotification = false;
  basketTotalCost!: number;

  created() {
    this.location = this.$route.query.l as string;
    this.product = this.productSetting.products.find(x => x.portiFolio == this.$route.query.portiFolio as string && x.isoCountry == this.$route.query.c as string) as ProductData;
  }

  computed() {
    let v = mapGetters("productGridStore", ["cartLineItemArr"])
  }

  @Watch('currentPage')
  async onPropertyChanged(value: string, oldValue: string) {
    await this.getPriceList();
  }
 
  async mounted() {
    if (!this.product) {
      this.$router.push({ name: "Country" });
      return;
    }
    await this.getPriceList()

    this.$store.dispatch("productGridStore/addRequiredPaymentDetail",{
      groceryLocation: this.location,
      isoCountry: this.product.isoCountry,
      portFolio: this.product.portiFolio,
      key: this.priceList.key
    })
  }

  private getPriceList() {
    this.isLoading = true;
    const portiFolio = this.product.portiFolio;
    const isoCountry = this.product.isoCountry;
    const location = this.location;
    const page = this.currentPage;
    
    this.$store.dispatch("product/GetProducts", { portiFolio, isoCountry, location, page })
    .then(value => {
     this.priceList = value as PriceList;
    })
    .catch(err => { console.error(err); });

    this.rows = this.priceList.pagination.pageCount;
    this.perPage = this.priceList.pagination.pageSize;
    this.isLoading = false;
  }

  qtyCheckTotal() {
    let count = 0;
    let basketTotalCost = 0;
    if (this.itemsInCart) {
      this.itemsInCart.forEach(item => {
        count += item.count;
        basketTotalCost += item.lineTotalAmount;
      })

      this.$store.dispatch("productGridStore/addCartTotal",basketTotalCost);
    }
    return count;
  }

  qtyCheck(productRow: ProductRow) {
    const lineItem = this.itemsInCart.find(x => x.row.extra1 == productRow.extra1);
    if (lineItem) {
      return lineItem.count;
    }
    return 0;
  }

  qtyCheckPerItemAndTitle(productRow: ProductRow) {
    const lineItem = this.itemsInCart.find(x => x.row.extra1 == productRow.extra1);
    if (lineItem) {
      return `${lineItem.count} x ${lineItem.row.description}`;
    }
    return productRow.description;
  }

  addToCart(productRow: ProductRow) {
    const lineItem = this.itemsInCart.find(x => x.row.extra1 == productRow.extra1);
    const count1 = Number.parseInt((document.getElementById(productRow.extra1) as HTMLInputElement).value);
    const totalLineAmount = count1 * productRow.totalAmount;

    if (count1 === 0) {
      this.removeFromCart(productRow);
      return;
    }

    if (!lineItem) {
      const row = {
        row: productRow,
        count: count1,
        lineTotalAmount: totalLineAmount
      }
      this.$store.dispatch("productGridStore/addCartLineItem", row);
    }
    else {
      lineItem.count = count1
      lineItem.lineTotalAmount = totalLineAmount;
    }
  }

  private removeFromCart(productRow: ProductRow) {
    this.itemsInCart.splice(this.itemsInCart.findIndex(x => x.row.extra1 == productRow.extra1), 1);
  }

  proceed(): void {
    this.showNotification = false;
    if(this.basketTotalCost <100)
    {
      this.$bvToast.toast('Order placed should be minimum R100', {
        title: 'Notification',
        variant: 'danger',
        autoHideDelay: 5000,
      })
      return;
    }
    this.$router.push({ name: 'recepientDetails' })
  }
}

